import { render, staticRenderFns } from "./NicheIcon.vue?vue&type=template&id=2f8e032d&scoped=true"
import script from "./NicheIcon.vue?vue&type=script&lang=js"
export * from "./NicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e032d",
  null
  
)

export default component.exports